import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TestimonyStoriesComponent } from './testimony-stories.component'
import { TestimonyComponent } from './testimony/testimony.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [TestimonyStoriesComponent, TestimonyComponent],
  imports: [CommonModule, SharedModule],
  exports: [TestimonyStoriesComponent],
})
export class TestimonyStoriesModule {}
